// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2jKCS","more":"LTwPD","actions":"YLGRh","small":"_38M7p","extended":"sameS","actionsTop":"x9vcH YLGRh","buttonBorder":"_2B7gt"};